import Vue from "vue";
import visible from "@/directives/v-visible";

Vue.directive("visible", visible);
